import React from 'react';
import { RouteStat } from '../driverRoutesTypes';
import styles from './RouteStatsBar.module.css';

interface RouteStatsBarProps {
  stats: RouteStat[];
}

export const RouteStatsBar: React.FC<RouteStatsBarProps> = ({ stats }) => {
  return (
    <div className={styles.bar}>
      {stats.map((stat) => (
        <div key={stat.id} className={styles.stat}>
          <p className={styles.label}>{stat.label}</p>
          <p className={styles.value}>{stat.value}</p>
        </div>
      ))}
    </div>
  );
};
